import { types, actions } from './requests'
export const GETRECIPELIST_TYPES = {
    ...types('GETRECIPELIST'),
}
export const GETRECIPELIST_ACTIONS = {
    ...actions('GETRECIPELIST'),
}